import React, { useEffect } from "react";
import { useDispatch, useStore } from "react-redux";
import {
  employeListActions,
  employeListActionsBulk,
  employerActions,
  genderTypeActions
} from "@store/actions";
import {
  reconcileDeletedEmployees
} from "@store/actions/commonData/_employerActions";
import { getPendingDeletedEmployeeIds } from "@store/actions/enterpriseEmployeData/_employeListBulkActions";
import "@css/pages/employer/DocumentsEmployers/documentsEmployer.css";
import "@responsivity/responsivityDesktop/employer.css";
import "@responsivity/responsivityMobile/Employer/listEmployer.css";
import Index from "./container";
import { useReduxSelector } from "@hooks/useReduxSelector";

export default function EmployeTab({isAllowedTabs}) {
  const reduxDispatch = useDispatch();
  const store = useStore();

  const employeList = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.employeList
  );
  const employeListBulk = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.employeListBulk
  );

  const genderType = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.genderType
  );

  useEffect(() => {
    if (!employeList?.isLoaded) {
      reduxDispatch(employeListActions.loadData);
    } else if (employeList.isDataOutdated) {
      reduxDispatch(employeListActions.refreshData);
    }
  }, [employeList?.isDataOutdated, employeList?.isLoaded, reduxDispatch]);

  useEffect(() => {
    if (!employeListBulk?.isLoaded) {
      reduxDispatch(employeListActionsBulk.loadData);
    } else if (employeListBulk.isDataOutdated) {
      reduxDispatch(employeListActionsBulk.refreshData);
    }
  }, [
    employeListBulk?.isDataOutdated,
    employeListBulk?.isLoaded,
    reduxDispatch
  ]);

  useEffect(() => {
    const syncDeletedEmployeesAndRefresh = () => {
      const { reconciledDeletedEmployeeIds } = store.getState().enterpriseEmployeData.employeListBulk;
      if (!getPendingDeletedEmployeeIds(reconciledDeletedEmployeeIds).length) return;

      reduxDispatch(reconcileDeletedEmployees());
      reduxDispatch(employeListActions.refreshData);
      reduxDispatch(employeListActionsBulk.refreshData);
      reduxDispatch(employerActions.refreshEmployersList());
    };

    syncDeletedEmployeesAndRefresh();

    if (!genderType?.isLoaded) reduxDispatch(genderTypeActions.loadData);

    const handleVisibilitySync = () => {
      if (!document.hidden) {
        syncDeletedEmployeesAndRefresh();
      }
    };

    window.addEventListener("focus", syncDeletedEmployeesAndRefresh);
    document.addEventListener("visibilitychange", handleVisibilitySync);

    return () => {
      window.removeEventListener("focus", syncDeletedEmployeesAndRefresh);
      document.removeEventListener("visibilitychange", handleVisibilitySync);
    };
  }, []);

  return <Index isAllowedTabs={isAllowedTabs}/>;
}
